var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgNewHasNoResults = function SvgNewHasNoResults(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 113.46 95.88",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#2e63f7;}.cls-2{fill:#ffc466;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M113.44,18.67V8.52A8.53,8.53,0,0,0,104.92,0H35.79a8.53,8.53,0,0,0-8.52,8.52V18.77a.71.71,0,0,0,0,.21V62.87A9.73,9.73,0,0,0,37,72.58h66.72a9.73,9.73,0,0,0,9.72-9.71V18.74A.25.25,0,0,0,113.44,18.67ZM35.79,1.57h69.13a7,7,0,0,1,7,7V18h-83V8.52A7,7,0,0,1,35.79,1.57ZM103.74,71H37a8.15,8.15,0,0,1-8.14-8.14V19.55h83V62.87A8.15,8.15,0,0,1,103.74,71Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 9.42,
    y: 42.38,
    width: 38.37,
    height: 34.91
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M52.41,34a4.31,4.31,0,0,0-4.3,4.3V49.12h8.62V38.33A4.35,4.35,0,0,0,52.41,34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M56.73,49.73H48.11a.61.61,0,0,1-.61-.61V38.33a4.91,4.91,0,0,1,4.91-4.91,5,5,0,0,1,4.94,4.91V49.12A.61.61,0,0,1,56.73,49.73Zm-8-1.22h7.4V38.33a3.7,3.7,0,0,0-7.4,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M50.05,60.25V38.36a7.11,7.11,0,0,1,1.42-4.3h-39a5.16,5.16,0,0,0-5.14,5.08L7,79.64H33a1.48,1.48,0,0,1,1.48,1.47v6.15A7.78,7.78,0,0,0,49.8,89.37C49.8,81,50.05,66.43,50.05,60.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M42.28,95.88a8.54,8.54,0,0,1-8.43-8.62V81.11a.86.86,0,0,0-.86-.86H7a.58.58,0,0,1-.43-.18.59.59,0,0,1-.18-.44L6.7,39.14a5.8,5.8,0,0,1,5.75-5.7h39a.62.62,0,0,1,.49,1,6.51,6.51,0,0,0-1.3,3.93V60.25c0,2.85,0,7.48-.11,12.47-.06,5.68-.14,12.12-.14,16.65a.41.41,0,0,1,0,.16A8.46,8.46,0,0,1,42.28,95.88ZM7.61,79H33a2.09,2.09,0,0,1,2.09,2.08v6.15a7.17,7.17,0,0,0,14.11,2c0-4.54.07-10.93.13-16.59.06-5,.11-9.6.11-12.45V38.36a7.82,7.82,0,0,1,.92-3.69H12.45a4.56,4.56,0,0,0-4.52,4.48ZM49.8,89.37h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M51,86.89A14.89,14.89,0,1,1,61.49,61.47,15,15,0,0,1,65.85,72a13.16,13.16,0,0,1-.1,1.55A15,15,0,0,1,51.18,86.89ZM51,58.6a13.4,13.4,0,0,0-9.48,22.88A13.11,13.11,0,0,0,51.1,85.4a13.48,13.48,0,0,0,13.17-12h0A12.3,12.3,0,0,0,64.36,72,13.38,13.38,0,0,0,51,58.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M34.45,79.48H.61v4.67c0,9,6.45,11.1,10.78,11.1H40.85c-2.19-2.09-6.37-3.61-6.37-11.1V79.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M40.85,95.86H11.38C5.88,95.86,0,92.78,0,84.15V79.48a.61.61,0,0,1,.61-.62H34.48a.61.61,0,0,1,.61.62v4.67c0,5.79,2.52,7.74,4.74,9.46a17.89,17.89,0,0,1,1.44,1.19.64.64,0,0,1,.15.68A.62.62,0,0,1,40.85,95.86ZM1.23,80.09v4.06c0,9.73,7.77,10.48,10.15,10.48H39.15l-.07,0c-2.2-1.71-5.22-4-5.22-10.43V80.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M73.11,91.65,63.47,82l-2.54,2.53,9.65,9.65a1.79,1.79,0,1,0,2.53-2.54Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 36.04,
    cy: 9.83,
    r: 2.59
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M36,13a3.21,3.21,0,1,1,3.21-3.21A3.21,3.21,0,0,1,36,13Zm0-5.19a2,2,0,1,0,2,2A2,2,0,0,0,36,7.85Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 50.65,
    cy: 9.83,
    r: 2.59
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50.65,13a3.21,3.21,0,1,1,3.2-3.21A3.21,3.21,0,0,1,50.65,13Zm0-5.19a2,2,0,1,0,2,2A2,2,0,0,0,50.65,7.85Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 65.25,
    cy: 9.92,
    r: 2.59
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M65.25,13.13a3.21,3.21,0,1,1,3.21-3.21A3.21,3.21,0,0,1,65.25,13.13Zm0-5.19a2,2,0,1,0,2,2A2,2,0,0,0,65.25,7.94Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 14.74,
    y: 42.69,
    width: 26.13,
    height: 1.23
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 14.74,
    y: 55.84,
    width: 26.13,
    height: 1.23
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 14.74,
    y: 62.41,
    width: 14.5,
    height: 1.23
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 14.51,
    y: 49.26,
    width: 26.13,
    height: 1.23
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNewHasNoResults, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/newHasNoResults.48f7c4a5.svg";
export { ForwardRef as ReactComponent };